var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.932,
    height: 139.932,
    viewBox: "0 0 37.024 37.024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter13400",
    width: 1.037,
    height: 1.048,
    x: -0.019,
    y: -0.024,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.156
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80.518 -66.751)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.024,
    height: 37.024,
    x: 80.518,
    y: 66.751,
    fill: "none",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.754,
    opacity: 1,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "none",
    strokeWidth: 0.56,
    transform: "matrix(.97124 0 0 .97124 -1.166 4.793)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "#242424",
    d: "M105.974 69.85c-.645 0-1.164.52-1.164 1.165V90.84c0 .645.519 1.164 1.164 1.164h14.117c.645 0 1.165-.519 1.165-1.164V71.015c0-.645-.52-1.165-1.165-1.165zm-18.483 5.208c-.645 0-1.165.519-1.165 1.164v19.826c0 .645.52 1.165 1.165 1.165h14.116c.646 0 1.165-.52 1.165-1.165V76.222c0-.645-.52-1.164-1.165-1.164z",
    filter: "url(#filter13400)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.145 3.337)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.446,
    height: 22.156,
    x: 78.551,
    y: 69.99,
    fill: "#f8f9fa",
    fillOpacity: 1,
    stroke: "#242424",
    opacity: 1,
    ry: 1.165
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.083,
    height: 8.083,
    x: 82.733,
    y: 72.383,
    fill: "#3b69a5",
    fillOpacity: 1,
    stroke: "#242424",
    opacity: 1,
    ry: 1.614
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    fillOpacity: 1,
    stroke: "#242424",
    d: "M81.216 83.07h9.904",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    fillOpacity: 1,
    stroke: "#242424",
    d: "M81.216 84.46h9.904",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    fillOpacity: 1,
    stroke: "#242424",
    d: "M81.216 87.26h9.904",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    fillOpacity: 1,
    stroke: "#242424",
    d: "M81.216 88.8h9.904",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.864,
    cy: 83.631,
    r: 0.843,
    fill: "#f8f9fa",
    fillOpacity: 1,
    stroke: "#3b69a5",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f9fa",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M92.11 88.787l1.711-1.711",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f9fa",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M92.11 87.076l1.711 1.711",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.446,
    height: 22.156,
    x: 97.034,
    y: 64.783,
    fill: "#3b69a5",
    fillOpacity: 1,
    stroke: "#242424",
    opacity: 1,
    ry: 1.165
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.083,
    height: 8.083,
    x: 101.216,
    y: 67.175,
    fill: "#aec6dd",
    fillOpacity: 1,
    stroke: "#f8f9fa",
    opacity: 1,
    ry: 1.614
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aec6dd",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M99.7 77.862h9.903",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aec6dd",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M99.7 79.252h9.903",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aec6dd",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M99.7 82.053h9.903",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aec6dd",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M99.7 83.593h9.903",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.458,
    cy: 82.64,
    r: 0.843,
    fill: "#3b69a5",
    fillOpacity: 0,
    stroke: "#f8f9fa",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f9fa",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M110.777 79.362l1.711-1.711",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aec6dd",
    fillOpacity: 1,
    stroke: "#aec6dd",
    d: "M110.777 77.65l1.711 1.712",
    opacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareDraft);
export default __webpack_public_path__ + "static/media/compare_draft.2d53af0557c875c627fc6fb19372ae99.svg";
export { ForwardRef as ReactComponent };